<div [ngClass]="{'pointer-events-none': SolutionStatus.PUBLISHED !== solution.status}" [routerLink]="['/', tenant, RouterSegments.SERVICES, solution.id]" 
class="solution-card">
  <div *ngIf="SolutionStatus.PUBLISHED !== solution.status" class="flex items-center coming-soon fs-14 p-8">
    {{ "CATALOGUE.COMING_SOON" | transloco }}
  </div>
  <div [ngClass]="{'disabled mt-30': SolutionStatus.PUBLISHED !== solution.status}" class="solution-data">
    <div class="flex items-center mat-headline-5 mb-10 card-title word-break-word">
      {{solution.name}}
    </div>
    <div *ngIf="capabilities" class="flex overline-font mb-16 card-subtitle">
      <mat-icon class="mr-8 icon-sm mt-4" svgIcon="layers"></mat-icon>
      <span class="mt-4">{{capabilities}} {{"CATALOGUE.CAPABILITIES" | transloco}}</span>
    </div>
    <div [ngClass]="capabilities ? 'text-with-capabilties' : 'text-without-capabilties'" class="mat-body-2 mb-15 description fw-400">{{solution.shortDescription}}</div>
  </div>
</div>
